import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

/**
 * Hook to manage a URL search parameter with getter and setter
 * Uses react-router's useLocation for reactivity
 */
export default function useUrlParam(
  key: string
): [string | null, (value: string | null) => void] {
  const history = useHistory()
  const location = useLocation()

  const value = useMemo(() => {
    const params = new URLSearchParams(location.search)
    return params.get(key)
  }, [location.search, key])

  const setValue = useCallback(
    (newValue: string | null) => {
      const params = new URLSearchParams(location.search)
      if (newValue === null || newValue === undefined || newValue === '') {
        params.delete(key)
      } else {
        params.set(key, newValue)
      }
      const search = params.toString()
      history.push({ pathname: location.pathname, search: search ? `?${search}` : '' })
    },
    [key, history, location.pathname, location.search]
  )

  return [value, setValue]
}
